import { Component, OnInit, Input, Inject } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-loyalty-cta',
    templateUrl: './loyalty-cta.shared.component.html',
    styleUrls: ['./loyalty-cta.shared.component.scss']
})
export class LoyaltyCTAComponent implements OnInit {
    @Input() public feel!: OLO.Components.EXPANDED_SECTION_FEEL;
    @Input() public btnFeel!: OLO.Components.BUTTON_FEEL | OLO.Components.BUTTON_CIRCLE_FEEL;
    @Input() public btnInverted!: boolean;
    @Input() public titleInverted!: boolean;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
    ) { }

    ngOnInit(): void { }

    public get description(): string[] {
        return this.config.ui?.loyalty?.cta?.description || [];
    }

    public get title(): string {
        return this.config?.ui?.loyalty?.cta?.title || '';
    }

    public handleCreateAccountClick($event: Event): void {
        this.controllers.loyalty.createAccountWithMemberCard();
    }

    public get backgroundFeel(): OLO.Components.EXPANDED_SECTION_FEEL {
        return this.feel || this.config.ui?.loyalty?.cta?.sectionFeel || 'primary';
    }

    public get buttonFeel(): OLO.Components.BUTTON_FEEL | OLO.Components.BUTTON_CIRCLE_FEEL {
        return this.btnFeel || this.config.ui?.loyalty?.cta?.btnFeel || 'secondary';
    }

    public get buttonInverted(): boolean {
        return this.btnInverted !== undefined ? this.btnInverted : this.config.ui?.loyalty?.cta?.btnInverted !== undefined ? this.config.ui?.loyalty?.cta?.btnInverted : true;
    }

    public get headerInverted(): boolean {
        return this.titleInverted !== undefined ? this.titleInverted : this.config.ui?.loyalty?.cta?.titleInverted !== undefined ? this.config.ui?.loyalty?.cta?.titleInverted : true;
    }
}
